import { Component, OnInit, Inject, Input } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';

@Component({
    selector: 'ebb-portal-dialog-permission',
    templateUrl: './dialog-permission.component.html',
    styleUrls: ['./dialog-permission.component.scss'],
    standalone: false
})
export class DialogPermissionComponent implements OnInit {
  public formPermissions: FormGroup;
  public disableGrantSave = true;
  public grantPermission: number;
  public termsOfUseLink:string;
  public termsOfUseLinkText:string;
  public programRulesLink:string;
  public programRulesLinkText:string;

  constructor(
    public readonly dialogRef: MatDialogRef<DialogPermissionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fb: FormBuilder   
  ) { 
    this.termsOfUseLinkText = 'Terms & Conditions';
    this.programRulesLinkText = 'Program Rules';

    if (data.programType === 700000000) { //CEA BB
      this.termsOfUseLink = '/Cea-Bb-Terms-of-Use';
      this.programRulesLink = '/What-is-CEABB/Program-Rules';
    } else {
      if (data.programType === 700000003) { //ESS
        this.termsOfUseLink = '/Ess-Terms-of-Use';
        this.programRulesLink = '/What-is-ESS/Program-Rules';
      } else {
        this.termsOfUseLink = '/Terms-of-Use';
        this.programRulesLink = '/What-is-EBB/Program-Rules';
      }
    }
  }

  ngOnInit() {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.formPermissions = this.fb.group({
      managePermission: ''
    });
  }

  public onChangeEventPermissions(event: MatRadioChange): void {
    this.grantPermission = parseInt(event.value.toString(), 10);
    (this.grantPermission === 700000001) 
      ? this.disableGrantSave = false
      : this.disableGrantSave = true;
  }

  public onCheckEventPermissions(event): void {
    if (event.checked) {
      this.grantPermission = 700000001;
      this.disableGrantSave = false;
    } else {
      this.grantPermission = 0;
      this.disableGrantSave = true;
    }
  }

  public onClickPermissions(): void {
    this.dialogRef.close(this.grantPermission);
  }

  public onNoClick() : void {
    this.dialogRef.close(700000002);
  }

}
